import { Reveal } from "@/components/shared/Reveal";
import { OrbitArcs } from "@/components/shared/Motifs";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

export function WhyTiming() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].whyTiming;

  return (
    <section className="relative overflow-hidden bg-cream py-20 sm:py-28" data-testid="why-timing">
      <OrbitArcs className="pointer-events-none absolute -right-24 top-1/2 h-[360px] w-[360px] -translate-y-1/2 text-navy/[0.05]" />
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="mb-3 flex items-center gap-2">
              <span className="h-px w-6 bg-gold" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">{t.eyebrow}</span>
            </div>
            <h2 className="font-heading text-3xl font-semibold leading-tight text-navy sm:text-4xl lg:text-5xl">
              {t.title}
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="space-y-5 border-l-2 border-gold/40 pl-6 sm:pl-8">
            {t.paras.map((p, i) => (
              <Reveal key={i} delay={i * 100}>
                <p className={`leading-relaxed text-navy/75 ${i === t.paras.length - 1 ? "text-lg font-medium text-navy" : "text-base"}`}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
